import { render, staticRenderFns } from "./distributionBusinessGroup.vue?vue&type=template&id=684a0a99&scoped=true"
import script from "./distributionBusinessGroup.vue?vue&type=script&lang=js"
export * from "./distributionBusinessGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a0a99",
  null
  
)

export default component.exports